/**
 * Modules dependencies
 */
const https = require('https');

const querystring = require('querystring');
const NordicRestClient = require('nordic/restclient');
/**
 * This client is browser ONLY (using the internal API). This file is going to be the restclient.browser.js
 */
const rcConfig = require('../../config/restclient')({
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
});

const restclient = NordicRestClient(rcConfig);

/**
 * Service interface
 */
class PaymentMethodsService {
  /**
   * Get Flow
   * @param version (tokenizer, checkout)
   * @param flowId
   * @param type (embed, modal, redirect)
   * @param step to get
   * @param action
   * @param urlParams
   * @param options
   * @returns {Promise<T>}
   */
  static async get({ params }) {
    return restclient
      .get(`/payment-methods`, {
        params,
      })
      .then(({ data }) => data?.results || [])
      .catch(async (err) => Promise.reject(err));
  }
}

/**
 * Expose Service
 */
module.exports = PaymentMethodsService;
